import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect, useMemo } from 'react';
import RecommendationsView from '../components/BookRecommender/RecommendationsView';
import { useMoodRecommendations } from '../components/BookRecommender/hooks/useMoodRecommendations';
import LoadingModal from '../components/LoadingModal';

function RecommendationsPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [recommendations, setRecommendations] = useState([]);
  const [error, setError] = useState(null);
  const { getRecommendations, isLoading } = useMoodRecommendations();
  
  // Destructure with default empty object to avoid errors
  const { 
    mode, 
    mood, 
    books, 
    recommendations: initialRecommendations,
    analysis 
  } = location.state || {};

  useEffect(() => {
    // Redirect to home if no state is present
    if (!mode || (!mood && !books)) {
      navigate('/');
      return;
    }

    // Handle mood-based recommendations
    if (mode === 'mood' && mood) {
      const fetchMoodRecommendations = async () => {
        try {
          // FIX: Use correct signature for mood-based recommendations
          const results = await getRecommendations('mood', mood.mood, 4, [], []);
          if (results) {
            setRecommendations(results);
          }
        } catch (error) {
          console.error('Error fetching mood recommendations:', error);
          // For limit reached errors, let RecommendationsView handle the paywall
          if (!error.message.includes('limit reached')) {
            setError(error.message || 'Failed to fetch recommendations');
          }
        }
      };
      fetchMoodRecommendations();
      return;
    }

    // Handle similar books recommendations
    if (mode === 'similar' && initialRecommendations) {
      setRecommendations(initialRecommendations);
    }
  }, [mode, mood, books, navigate, getRecommendations, initialRecommendations]);

  const handleNewSearch = () => {
    navigate('/');
  };
  
  // Remove the useMemo with JSON.stringify, just use recommendations directly

  if (mode === 'mood' && isLoading) {
    return <LoadingModal isOpen={true} />;
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center space-y-4">
          <h2 className="text-2xl font-medium text-gray-900">Oops!</h2>
          <p className="text-gray-600">{error}</p>
          <button
            onClick={handleNewSearch}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <RecommendationsView
      recommendations={recommendations}
      mode={mode}
      selectedMood={mood}
      selectedBooks={books || []}
      onNewSearch={handleNewSearch}
    />
  );
}

export default RecommendationsPage; 